export const anchorItems = [
  { key: "Basic", href: "#basic", title: "Basic" },
  {
    key: "Interests-personality",
    href: "#interests-personality",
    title: "Interests & personality",
  },
  { key: "Contact", href: "#contact", title: "Contact" },
  { key: "Career", href: "#career", title: "Career" },
  { key: "Physical", href: "#physical", title: "Physical" },
  { key: "Family", href: "#family", title: "Family" },

  {
    key: "Partner-preferences",
    href: "#partner-preferences",
    title: "Partner preferences",
  },
];

export const selectFields = [
  "Marital status",
  "Religion",
  "Community",
  "Gender",
  "Nationality",
  "Mother tongue",
  "Language",
  "Diet",
  "Smoking",
  "Drinking",
  "Interested in moving abroad",
  "Employment",
];

export const selectEditOptions = {
  "Marital status": [
    { value: "single", label: "Single" },
    { value: "married", label: "Married" },
    { value: "divorced", label: "Divorced" },
    { value: "widowed", label: "Widowed" },
  ],
  Religion: [
    { value: "hindu", label: "Hindu" },
    { value: "muslim", label: "Muslim" },
    { value: "christian", label: "Christian" },
    { value: "sikh", label: "Sikh" },
    { value: "jain", label: "Jain" },
    { value: "buddhist", label: "Buddhist" },
    { value: "parsi", label: "Parsi" },
    { value: "other", label: "Other" },
  ],
  Community: [
    { value: "brahmin", label: "Brahmin" },
    { value: "nair", label: "Nair" },
    { value: "chettiar", label: "Chettiar" },
    { value: "maratha", label: "Maratha" },
    { value: "reddy", label: "Reddy" },
    { value: "other", label: "Other" },
  ],
  Gender: [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
  ],
  Nationality: [
    { value: "indian", label: "Indian" },
    { value: "american", label: "American" },
    { value: "canadian", label: "Canadian" },
    { value: "british", label: "British" },
    { value: "australian", label: "Australian" },
    { value: "other", label: "Other" },
  ],
  "Mother tongue": [
    { value: "hindi", label: "Hindi" },
    { value: "tamil", label: "Tamil" },
    { value: "telugu", label: "Telugu" },
    { value: "malayalam", label: "Malayalam" },
    { value: "kannada", label: "Kannada" },
    { value: "bengali", label: "Bengali" },
    { value: "marathi", label: "Marathi" },
    { value: "punjabi", label: "Punjabi" },
    { value: "other", label: "Other" },
  ],
  Language: [
    { value: "english", label: "English" },
    { value: "hindi", label: "Hindi" },
    { value: "tamil", label: "Tamil" },
    { value: "telugu", label: "Telugu" },
    { value: "malayalam", label: "Malayalam" },
    { value: "other", label: "Other" },
  ],
  Diet: [
    { value: "vegetarian", label: "Vegetarian" },
    { value: "non_vegetarian", label: "Non-Vegetarian" },
    { value: "eggetarian", label: "Eggetarian" },
    { value: "vegan", label: "Vegan" },
  ],
  Smoking: [
    { value: "no", label: "No" },
    { value: "yes", label: "Yes" },
    { value: "occasionally", label: "Occasionally" },
  ],
  Drinking: [
    { value: "no", label: "No" },
    { value: "yes", label: "Yes" },
    { value: "occasionally", label: "Occasionally" },
  ],
  "Interested in moving abroad": [
    { value: 0, label: "Yes" },
    { value: 1, label: "No" },
  ],
  "Grew up in": [],
};

export const editCurrentLocationDetails = {
  Country: [],
  State: ["Kerala", "Tamil Nadu", "Karnataka"],
  District: ["Calicut", "Ernakulam", "Trivandrum"],
  Town: ["Ashokapuram", "Mavoor", "Kozhikode"],
};

export const editPermanentAddressDetails = {
  Country: [],
  State: ["Karnataka", "Tamil Nadu", "Kerala"],
  District: ["Bangalore", "Mysore", "Hubli"],
  Town: ["Bangalore", "Whitefield", "Electronic City"],
};

export const careerSelectOptions = {
  Qualification: [
    "High School",
    "Diploma",
    "Bachelor's Degree",
    "Master's Degree",
    "PhD",
  ],
  "Annual Income": [
    "< ₹5 LPA",
    "₹5-10 LPA",
    "₹10-15 LPA",
    "₹15-20 LPA",
    "₹20+ LPA",
  ],
  Employment: ["Full-time", "Part-time", "Self-employed", "Unemployed"],
  Sector: [
    "IT",
    "Finance",
    "Healthcare",
    "Education",
    "Engineering",
    "Government",
    "Other",
  ],
  Course: [],
  Profession: [],
};

export const familySelectOptions = {
  "Family Type": ["Nuclear", "Joint", "Extended"],
  "Father Occupation": ["Employed", "Retired", "Business", "No More"],
  "Mother Occupation": ["Homemaker", "Employed", "Business", "No More"],
  sibling: [
    { id: 0, label: "0", value: 0 },
    { id: 1, label: "1", value: 1 },
    { id: 2, label: "2", value: 2 },
    { id: 3, label: "3", value: 3 },
    { id: 4, label: "4", value: 4 },
    { id: 5, label: "5", value: 5 },
  ],
  "Financial Status": [
    "Lower",
    "Middle Class",
    "Upper Middle Class",
    "Rich",
    "Affluent",
  ],
};

export const physicalSelectOptions = {
  Weight: Array.from({ length: 81 }, (_, i) => `${40 + i} kg`),
  Height: Array.from({ length: 71 }, (_, i) => `${140 + i} cm`),
  "Body Type": ["Slim", "Athletic", "Average", "Heavy"],
  "Physical Status": ["Normal", "Physically Challenged"],
  Complexion: ["Very Fair", "Fair", "Wheatish", "Dark"],
  "Blood Group": [
    "A +ve",
    "A -ve",
    "B +ve",
    "B -ve",
    "O +ve",
    "O -ve",
    "AB +ve",
    "AB -ve",
  ],
};

export const fieldLabels = {
  // ✅ Basic Info
  first_name: "First Name",
  last_name: "Last Name",
  marital_status: "Marital Status",
  religion: "Religion",
  sub_religion: "Community",
  gender: "Gender",
  mother_tongue: "Mother Tongue",
  dob: "Date of Birth",
  country: "Nationality",
  city: "Grew up in",
  smoke: "Smoking",
  drink: "Drinking",
  interested_in_moving_abroad: "Interested in moving abroad",
  custom_location: "Lives in",

  // ✅ Current Address
  living_city: "State",
  living_place: "District",
  living_town: "Town",
  living_pin: "Pincode",

  // ✅ Permanent Address
  permanent_city: "Permanent State",
  place: "Permanent District",
  town: "Permanent Town",
  pin: "Permanent Pincode",

  // ✅ Contact Info
  phone: "Contact Number",
  whatsapp_number: "Whatsapp Number",
  email: "Email ID",

  // ✅ Career Details
  qualification: "Qualification",
  course: "Course",
  company: "Company name",
  sector: "Sector",
  employment_type: "Employment",
  occupation: "Occupation",
  annual_income: "Annual Income",

  // ✅ Physical Appearance
  weight: "Weight",
  height: "Height",
  blood_group: "Blood Group",
  complexion: "Complexion",
  body_type: "Body Type",
  physical_status: "Physical Status",

  // ✅ Family Details
  family_type: "Family Type",
  family_status: "Financial status",
  father_name: "Father Name",
  father_occupation: "Father Occupation",
  mother_name: "Mother Name",
  mother_occupation: "Mother Occupation",
  num_sisters: "Sister",
  num_brothers: "Brother",
  num_brothers_married: "Married Sister",
  num_sisters_married: "Married Brother",
};
